import ApiService from './api.service';

class SalePointTypeService {
  async list() {
    try {
      const response = await ApiService.get('/sale-point-type');
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async create(data) {
    try {
      const response = await ApiService.post('/sale-point-type/add', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async update(data) {
    try {
      const response = await ApiService.put('/sale-point-type/update', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async delete(id) {
    try {
      const response = await ApiService.delete('/sale-point-type/delete', { id });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default new SalePointTypeService(); 